import { useState } from "react";

export default function useContactForm(ORCHESTRATOR_URL) {
  const [contact, setContact] = useState({ name: "", email: "", message: "" });
  const [contactStatus, setContactStatus] = useState(null);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus("Sending...");
    try {
      await fetch(`${ORCHESTRATOR_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contact),
      });
      setContactStatus("Message sent!");
      setContact({ name: "", email: "", message: "" });
    } catch (error) {
      setContactStatus("Failed to send. Please try again.");
    }
  };

  return { contact, setContact, contactStatus, handleContactSubmit };
}
